import { type StudyStatus } from './content/evidenceContent';

interface Props {
	status: StudyStatus;
}

const statusConfig = {
	upcoming: {
		label: 'Upcoming',
		className: 'bg-blue-100 text-blue-700',
	},
	underway: {
		label: 'Underway',
		className: 'bg-green-100 text-green-700',
	},
	completed: {
		label: 'Completed',
		className: 'bg-gray-100 text-gray-700',
	},
} as const;

export function StatusBadge({ status }: Props) {
	const config = statusConfig[status];

	return (
		<span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${config.className}`}>
			{config.label}
		</span>
	);
}
